import { Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'hfc-signup-shell',
  templateUrl: './signup-shell.component.html'
})
export class SignupShellComponent {
  hasResetToken$ = this.route.queryParamMap.pipe(map((qp) => !!qp.get('reset-token')));

  constructor(private route: ActivatedRoute) {}
}
